/**
 * TKP-27 / K3 — `department.parent` ile birim ağacı (üst birim modülü kalktı). Saf: store'a bağımlı değil.
 * Bozuk veri (a↔b döngüsü, silinmiş üst) kök sayılır; hiçbir kayıt iki kez yerleşmez.
 */
const idOf = (ref) => (ref && ref._id ? String(ref._id) : ref ? String(ref) : undefined);

export const buildDepartmentTree = (docs = [], label = (d) => d.name) => {
  const byId = new Map(docs.map((d) => [String(d._id), { ...d, children: [] }]));
  const roots = [];
  for (const node of byId.values()) {
    const parentId = idOf(node.parent);
    const parent = parentId && parentId !== String(node._id) ? byId.get(parentId) : undefined;
    if (parent) parent.children.push(node);
    else roots.push(node);
  }
  // döngüdeki düğümler (hiçbiri köke ulaşmaz) → kök olarak yüzeye çıkar
  const reachable = new Set();
  const walk = (n) => { if (reachable.has(String(n._id))) return; reachable.add(String(n._id)); n.children.forEach(walk); };
  roots.forEach(walk);
  for (const node of byId.values()) {
    if (reachable.has(String(node._id))) continue;
    // döngü kenarını kopar: üstünün çocuk listesinden çıkar, kök yap (render sonsuz döngüye girmesin)
    const parent = byId.get(idOf(node.parent));
    if (parent) parent.children = parent.children.filter((c) => c !== node);
    roots.push(node);
    walk(node);
  }
  const sort = (list) => { list.sort((a, b) => String(label(a) ?? "").localeCompare(String(label(b) ?? ""))); list.forEach((n) => sort(n.children)); };
  sort(roots);
  return { roots, byId };
};

/** Bir departmanın üst zinciri (yakından uzağa); döngüde durur. Formda "kendi alt ağacı" seçilmesin diye de kullanılır. */
export const ancestorsOf = (id, byId) => {
  const out = [];
  const seen = new Set([String(id)]);
  let cursor = byId.get(String(id));
  while (cursor) {
    const parentId = idOf(cursor.parent);
    if (!parentId || seen.has(parentId)) break;
    seen.add(parentId);
    cursor = byId.get(parentId);
    if (cursor) out.push(cursor);
  }
  return out;
};

/** `id`'nin alt ağacındaki id'ler (kendisi dahil) — üst birim seçiminde dışlanır. */
export const subtreeIds = (id, byId) => {
  const out = new Set();
  const stack = [byId.get(String(id))].filter(Boolean);
  while (stack.length) {
    const n = stack.pop();
    if (out.has(String(n._id))) continue;
    out.add(String(n._id));
    stack.push(...n.children);
  }
  return out;
};
